import { render, staticRenderFns } from "./distributionStore.vue?vue&type=template&id=3c31b988&scoped=true&"
import script from "./distributionStore.vue?vue&type=script&lang=js&"
export * from "./distributionStore.vue?vue&type=script&lang=js&"
import style0 from "./distributionStore.vue?vue&type=style&index=0&id=3c31b988&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c31b988",
  null
  
)

export default component.exports